import Facebook from './facebook';

export default Facebook;
